import apiClient from './ApiService'

export default {
  getFactorias(page = 1, limit = 15, filters = {}) {
    return apiClient.get('/factorias', {
      params: {
        page,
        limit,
        ...filters
      }
    })
  },
  
  getAllFactorias(filters = {}) {
    return apiClient.get('/factorias/all', {
      params: filters
    })
  },
  
  getFactoria(id) {
    return apiClient.get(`/factorias/${id}`)
  },
  
  createFactoria(factoria) {
    return apiClient.post('/factorias', factoria)
  },
  
  updateFactoria(id, factoria) {
    return apiClient.put(`/factorias/${id}`, factoria)
  },
  
  deleteFactoria(id) {
    return apiClient.delete(`/factorias/${id}`)
  }
}